import React, { useEffect, useState } from "react";
import { getApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import minster from '../sketches/minster.svg';
import manorHouse from '../sketches/manor-house.svg';

function BigDay() {
  const auth = getAuth(getApp());
  // default to false to avoid briefly showing the rest of the schedule
  // to users who are only invited to the night do:
  const [isNightDo, setIsNightDo] = useState(true);
  const [schedule, setSchedule] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      user.getIdTokenResult()
        .then((idTokenResult) => {
          const isNightDo = idTokenResult.claims?.isNightDo ?? false;
          setIsNightDo(isNightDo);
        })
        .catch((err) => console.error("getIdTokenResult error:", err));
    });

    return () => unsubscribe();
  }, [auth]);

  useEffect(() => {
    fetch('/big-day.json')
      .then((res) => res.json())
      .then((data) => setSchedule(data))
      .catch((err) => console.error("Failed to load schedule:", err));
  }, []);

  if (!schedule) return null;

  return (
    <div className="container">
      <h1 className="tangerine-bold">The <u>Big</u> Day</h1>
      <p className="josefin-slab">
        A draft schedule for our wedding day for you to plan around.
        Details may change as we get closer to the date, but this should give you a good idea of how the day will flow.
      </p>

      <div className="content">
        <table className="big-day-timeline" style={{ width: "100%" }}>
          <tbody>
            {!(isNightDo && schedule.ceremony.fullDayOnly) && (
              <>
                <tr>
                  <td colSpan="2">
                    <img src={minster} alt="" width="200" />
                    <h2 className="josefin-slab upper">The Ceremony</h2>
                  </td>
                </tr>
                {schedule.ceremony.events.map(({ time, name }, index) => (
                  <tr key={index}>
                    <td><p className="josefin-slab">{time}</p></td>
                    <td><p className="josefin-slab">{name}</p></td>
                  </tr>
                ))}
              </>
            )}

            <tr>
              <td colSpan="2" style={{ paddingTop: "30px" }}>
                <img src={manorHouse} alt="" width="250" />
                <h2 className="josefin-slab upper">
                  {
                    isNightDo ? "The Night Do" : "The Reception"
                  }
                </h2>
              </td>
            </tr>

            {!(isNightDo && schedule.reception.fullDayOnly) && (
              <>
                {schedule.reception.events.map(({ time, name }, index) => (
                  <tr key={index}>
                    <td><p className="josefin-slab">{time}</p></td>
                    <td><p className="josefin-slab">{name}</p></td>
                  </tr>
                ))}
                <tr>
                  <td colSpan="2" style={{ paddingTop: "30px" }}>
                    <h2 className="josefin-slab upper">The Night Do</h2>
                  </td>
                </tr>
              </>
            )}

            {schedule.nightDo.events.map(({ time, name }, index) => (
              <tr key={index}>
                <td><p className="josefin-slab">{time}</p></td>
                <td><p className="josefin-slab">{name}</p></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default BigDay;